import {FormComponent} from "../../components/FormComponent";
import {Loader} from "../../components/Loader";
import React from "react";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {adminMenu} from "../../inc/AdminMenu";
import {User} from "../../components/User";
import {AdminPanel} from "../../components/AdminPanel";

export class CreateUser extends FormComponent {
    protected user: User = new User();
    protected needMount: boolean = false;

    protected getRequestUrl(): RequestInfo | URL {
        return '/user/create';
    }

    protected onSuccess(data: any, event: React.FormEvent | null): any {
        window.location.assign(`/user/edit/${data.id}`);
    }

    render() {
        if (this.needMount && this.state === null) {
            return <Loader/>;
        }

        return (
            <form className="x-form" onSubmit={this.handleSubmit}>

                <input type="hidden" name="id" defaultValue={this.state?.item.id || ''}/>

                <div className="row">

                    <div className="col-md-12 col-lg-5 col-xl-4 col-xxl-3">
                        <h5>{this.dictionary.get['data-user']}</h5>

                        <FormGroup.Input {...{id: 'name', required: true, defaultValue: this.state?.item.name}}/>

                        <FormGroup.Input {...{
                            id: 'email', type: 'email', required: true, defaultValue: this.state?.item.email
                        }}/>

                        <FormGroup.Select {...{
                            id: 'status',
                            required: true,
                            basic: 'please-select',
                            items: ['active', 'inactive'],
                            defaultValue: this.state?.item.status
                        }}/>

                        <FormGroup.Select {...{
                            id: 'role',
                            required: true,
                            basic: 'please-select',
                            items: ['admin', 'client', 'warehouse-admin'],
                            defaultValue: this.state?.item.role
                        }}/>

                        <FormGroup.Select {...{
                            id: 'language',
                            required: true,
                            basic: 'please-select',
                            items: this.dictionary.languages,
                            defaultValue: this.state?.item.language
                        }}/>

                        <div className="password-holder">
                            <h5 className="form-title">
                                <br/>&nbsp;
                                {this.dictionary.get['change-password']}
                            </h5>

                            <div className="alert alert-primary" role="alert">
                                <i className="bi bi-info-circle-fill color-blue"></i>
                                {this.dictionary.get['save-on-fill']}
                            </div>

                            <div className="form-group">
                                <label htmlFor="password"
                                       className="form-label">
                                    {this.dictionary.get['password']}
                                </label>
                                <input type="password" className="form-control form-control-sm" id="password"
                                       name="password" autoComplete={this.dictionary.get['save-on-fill']}
                                       aria-describedby="passHelp"/>
                                <small id="passHelp" className="form-text text-muted">
                                    <i className="bi bi-info-circle-fill color-blue"></i> {this.dictionary.get['min-8-char']}
                                </small>
                            </div>

                            <FormGroup.Input {...{
                                id: 'passwordRe',
                                label: 'password-again',
                                type: 'password',
                                autoComplete: this.dictionary.get['new-password']
                            }}/>
                        </div>

                        <FormSubmit/>
                    </div>

                    {this.editUserPermissions()}
                </div>
            </form>
        );
    }

    private editUserPermissions() {
        if (this.user.hasRight('user/edit-permissions') === false) {
            return '';
        }
        return (
            <div className="col-md-12 col-lg-7 col-xl-8 col-xxl-9 form-check-holder">
                <h5 key="rights-header">
                    {this.dictionary.get['edit-user-rights']}
                </h5>
                <div key="rights-alert" className="alert alert-primary" role="alert">
                    <i className="bi bi-info-circle-fill color-blue"></i>
                    {this.dictionary.get['effect-after-60-sec']}
                </div>
                <div key="rights-rights-list" className="row">
                    {this.getRightsList()}
                </div>
            </div>
        );
    }

    private getRightsList() {
        let list = [];
        for (let main in adminMenu.left) {
            list.push(<div key={main + 'adminMenu.left'} className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <h6 onClick={this.checkboxHeaderClick}>{this.dictionary.get[adminMenu.left[main].name]}</h6>
                {this.getRightsSetList(main)}
            </div>);
        }
        return list;
    }

    private getRightsSetList(main: string) {
        let list = [];
        for (let right in adminMenu.right[main]) {
            if (right === 'logout') {
                continue;
            }

            const label = this.dictionary.get[adminMenu.right[main][right].name] + "\n" + right;

            let defaultChecked = this.state?.rights && this.state.rights.includes(right);
            let disabled = false;

            if (AdminPanel.uriExceptions.includes(right)) {
                disabled = defaultChecked = true;
            }

            list.push(<FormGroup.Checkbox key={right + '-adminMenu.right'} {...{
                id: right,
                name: 'rights[]',
                value: right,
                labelText: label,
                disabled: disabled,
                defaultChecked: defaultChecked
            }}/>);
        }
        return list;
    }
}
